export const getCreateBankAccountPayload = (bankAccount, firstName, lastName, verificationCodeId) => {
  const payload = {
    first_name: firstName,
    last_name: lastName,
  }

  if (verificationCodeId) {
    payload.verification_code_id = verificationCodeId
  }

  //uk format
  if (bankAccount?.sortCode) {
    return {
      ...payload,
      sort_code: bankAccount.sortCode,
      bank_account_number: bankAccount.accountNumber,
    }
  }

  //europe format
  return {
    ...payload,
    bank_account_number: bankAccount,
  }
}
